import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import compose from 'recompose/compose';
import { connect } from 'react-redux';

import withToggle from '../../../common/hoc/withToggle';
import withPermissions from '../../../auth/utils/withPermissions';
import { canUserViewDailySummaryHistory } from '../../../common/helpers/users';
import { getActiveShop } from '../../../auth/selectors';

const enhance = compose(
  withPermissions,
  connect(
    state => ({
      user: state.auth.user,
      shop: getActiveShop(state),
    }),
  ),
  branch(
    props => !canUserViewDailySummaryHistory(props.user, props.permissions, props.shop),
    renderNothing,
  ),
  withToggle('downloadModal')
);

export default enhance;
